module.exports = __webpack_public_path__ + "static/media/roman_chair.4cb5926c.png";